import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Button, GlobalStyles, theme } from './uikit';
import { ConfigLoadError, loadConfig } from './config';
import { App } from './App';

function registerServiceWorker(): void {
  if (!import.meta.env.PROD) {
    return;
  }
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
}

function ConfigBootstrapErrorScreen({ message }: { message: string }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          justifyContent: 'center',
          minHeight: '100vh',
          padding: 24,
        }}
      >
        <p
          role="alert"
          style={{
            color: theme.colors.text.secondary,
            fontSize: theme.fontSizes[3],
            margin: 0,
            maxWidth: 400,
            textAlign: 'center',
          }}
        >
          {message}
        </p>
        <Button color="primary" type="button" variant="filled" onClick={() => window.location.reload()}>
          Повторить
        </Button>
      </div>
    </ThemeProvider>
  );
}

function configBootstrapUserMessage(err: unknown): string {
  if (err instanceof ConfigLoadError) {
    return err.message;
  }
  return 'Произошла ошибка. Нажмите «Повторить».';
}

loadConfig()
  .then(() => {
    registerServiceWorker();
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    );
  })
  .catch((err: unknown) => {
    const rootEl = document.getElementById('root');
    if (!rootEl) {
      return;
    }
    const body = `Ошибка загрузки приложения. ${configBootstrapUserMessage(err)}`;
    createRoot(rootEl).render(
      <StrictMode>
        <ConfigBootstrapErrorScreen message={body} />
      </StrictMode>,
    );
  });
